<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="list-product p-2">
        <div class="patient-shell">
          <div class="list-toolbar">
            <div class="toolbar-title">
              <h3>Patient Registration</h3>
              <p>Manage patient profile, payments and reports from one place.</p>
            </div>
            <div class="toolbar-actions">
              <button class="btn sr-trigger-btn position-relative" type="button" (click)="openApprovalQueue()">
                <i class="pi pi-globe"></i>
                <span class="sr-trigger-text">
                  <strong>Self-Registration</strong>
                  <small>Review online sign-ups</small>
                </span>
                <span class="sr-trigger-badge" *ngIf="pendingCount > 0">{{ pendingCount }}</span>
              </button>
              <button class="btn add-btn" type="button" (click)="openAddPatientDialog()">
                <i class="pi pi-plus"></i>
                Add Patient
              </button>
            </div>
          </div>

          <div
            class="sr-backdrop"
            [class.sr-backdrop--visible]="showOnlineQueue"
            (click)="closeApprovalQueue()"
            role="dialog"
            aria-modal="true"
            aria-labelledby="sr-panel-title"
          >
            <aside class="sr-panel" (click)="$event.stopPropagation()">
              <header class="sr-panel__header">
                <div class="sr-panel__title-wrap">
                  <span class="sr-panel__icon"><i class="pi pi-globe"></i></span>
                  <div>
                    <h2 id="sr-panel-title" class="sr-panel__title">Self-Registration Approvals</h2>
                    <p class="sr-panel__subtitle">Review patients who registered online before adding them to your records</p>
                  </div>
                </div>
                <button type="button" class="sr-panel__close" (click)="closeApprovalQueue()" aria-label="Close">
                  <i class="pi pi-times"></i>
                </button>
              </header>

              <div class="sr-panel__toolbar">
                <div class="sr-tabs">
                  <button
                    type="button"
                    class="sr-tab"
                    [class.sr-tab--active]="pendingStatusFilter === 'pending'"
                    (click)="loadPendingRegistrations('pending', 1, true)"
                  >
                    <i class="pi pi-clock"></i>
                    Awaiting
                    <span class="sr-tab__count sr-tab__count--amber" *ngIf="pendingCount > 0">{{ pendingCount }}</span>
                  </button>
                  <button
                    type="button"
                    class="sr-tab"
                    [class.sr-tab--active]="pendingStatusFilter === 'approved'"
                    (click)="loadPendingRegistrations('approved', 1, true)"
                  >
                    <i class="pi pi-check-circle"></i>
                    Approved
                    <span class="sr-tab__count sr-tab__count--green" *ngIf="pendingStatusFilter === 'approved' && pendingTotal">{{ pendingTotal }}</span>
                  </button>
                  <button
                    type="button"
                    class="sr-tab"
                    [class.sr-tab--active]="pendingStatusFilter === 'rejected'"
                    (click)="loadPendingRegistrations('rejected', 1, true)"
                  >
                    <i class="pi pi-times-circle"></i>
                    Rejected
                    <span class="sr-tab__count sr-tab__count--rose" *ngIf="pendingStatusFilter === 'rejected' && pendingTotal">{{ pendingTotal }}</span>
                  </button>
                </div>
                <button
                  type="button"
                  class="sr-refresh-btn"
                  (click)="loadPendingRegistrations(pendingStatusFilter, pendingPage)"
                  [disabled]="pendingLoading"
                  title="Refresh list"
                >
                  <i class="pi pi-refresh" [class.pi-spin]="pendingLoading"></i>
                </button>
              </div>

              <div class="sr-panel__filters">
                <div class="sr-search">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    [(ngModel)]="pendingSearch"
                    (ngModelChange)="onPendingSearchChange()"
                    placeholder="Search name, mobile, city…"
                  />
                  <button
                    type="button"
                    class="sr-search__clear"
                    *ngIf="pendingSearch"
                    (click)="clearPendingSearch()"
                    aria-label="Clear search"
                  >
                    <i class="pi pi-times"></i>
                  </button>
                </div>
                <span class="sr-result-count">{{ pendingPageLabel }}</span>
              </div>

              <div class="sr-panel__workspace" [class.sr-panel__workspace--loading]="pendingLoading">
                <div class="sr-table-pane">
                  <div class="sr-skeleton-table" *ngIf="pendingLoading">
                    <div class="sr-skeleton-row" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"></div>
                  </div>

                  <div class="sr-empty sr-empty--compact" *ngIf="!pendingLoading && !pendingRegistrations.length">
                    <span class="sr-empty__icon"><i class="pi pi-inbox"></i></span>
                    <h4 *ngIf="pendingStatusFilter === 'pending'">No sign-ups awaiting approval</h4>
                    <h4 *ngIf="pendingStatusFilter === 'approved'">No approved self-registrations</h4>
                    <h4 *ngIf="pendingStatusFilter === 'rejected'">No rejected self-registrations</h4>
                    <p *ngIf="pendingSearch">Try a different search term.</p>
                    <p *ngIf="!pendingSearch">New online registrations will appear here for review.</p>
                  </div>

                  <div class="sr-table-wrap" *ngIf="!pendingLoading && pendingRegistrations.length">
                    <table class="sr-table">
                      <thead>
                        <tr>
                          <th>Patient</th>
                          <th>Mobile</th>
                          <th>Age</th>
                          <th>City</th>
                          <th>Submitted</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let row of pendingRegistrations"
                          [class.sr-table__row--active]="selectedPendingRegistration?.id === row.id"
                          (click)="selectPendingRegistration(row)"
                        >
                          <td>
                            <div class="sr-table__name">{{ pendingFullName(row) }}</div>
                            <div class="sr-table__sub" *ngIf="row.gender">{{ row.gender }}</div>
                          </td>
                          <td>{{ row.primary_contact | phoneFormat }}</td>
                          <td>{{ row.age || '—' }}</td>
                          <td>{{ row.city || '—' }}</td>
                          <td>{{ row.created_at | date:'dd MMM yy' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="sr-pagination" *ngIf="!pendingLoading && pendingTotal > pendingPerPage">
                    <button type="button" class="sr-page-btn" (click)="pendingPagePrev()" [disabled]="pendingPage <= 1">
                      <i class="pi pi-chevron-left"></i>
                    </button>
                    <span>Page {{ pendingPage }} / {{ pendingLastPage }}</span>
                    <button type="button" class="sr-page-btn" (click)="pendingPageNext()" [disabled]="pendingPage >= pendingLastPage">
                      <i class="pi pi-chevron-right"></i>
                    </button>
                  </div>
                </div>

                <div class="sr-detail-pane">
                  <ng-container *ngIf="selectedPendingRegistration as row; else srDetailEmpty">
                    <div class="sr-detail__head">
                      <span class="sr-card__avatar">{{ getInitials(row) }}</span>
                      <div>
                        <h3 class="sr-detail__name">{{ pendingFullName(row) }}</h3>
                        <span class="sr-card__source"><i class="pi pi-globe"></i> Registered online</span>
                      </div>
                    </div>

                    <div class="sr-detail__facts">
                      <div class="sr-detail__fact">
                        <span>Mobile</span>
                        <strong>{{ row.primary_contact | phoneFormat }}</strong>
                      </div>
                      <div class="sr-detail__fact">
                        <span>Age / Gender</span>
                        <strong>{{ row.age ? row.age + ' yrs' : '—' }}{{ row.gender ? ' · ' + row.gender : '' }}</strong>
                      </div>
                      <div class="sr-detail__fact" *ngIf="row.blood_group">
                        <span>Blood group</span>
                        <strong>{{ row.blood_group }}</strong>
                      </div>
                      <div class="sr-detail__fact" *ngIf="row.city || row.state">
                        <span>Location</span>
                        <strong>{{ row.city || '—' }}{{ row.state ? ', ' + row.state : '' }}</strong>
                      </div>
                      <div class="sr-detail__fact sr-detail__fact--full" *ngIf="row.address">
                        <span>Address</span>
                        <strong>{{ row.address }}</strong>
                      </div>
                      <div class="sr-detail__fact">
                        <span *ngIf="pendingStatusFilter === 'pending'">Submitted</span>
                        <span *ngIf="pendingStatusFilter === 'approved'">Approved</span>
                        <span *ngIf="pendingStatusFilter === 'rejected'">Rejected</span>
                        <strong>
                          <ng-container [ngSwitch]="pendingStatusFilter">
                            <ng-container *ngSwitchCase="'pending'">{{ row.created_at | date:'dd MMM yyyy, h:mm a' }}</ng-container>
                            <ng-container *ngSwitchDefault>{{ (row.reviewed_at || row.updated_at) | date:'dd MMM yyyy, h:mm a' }}</ng-container>
                          </ng-container>
                        </strong>
                      </div>
                    </div>

                    <div class="sr-detail__approved" *ngIf="pendingStatusFilter === 'approved'">
                      <span class="sr-chip sr-chip--green" *ngIf="row.patient?.patient_number; else approvedOnly">
                        <i class="pi pi-id-card"></i> Patient #{{ row.patient.patient_number }}
                      </span>
                      <ng-template #approvedOnly>
                        <span class="sr-chip sr-chip--green"><i class="pi pi-check"></i> Added to records</span>
                      </ng-template>
                    </div>

                    <div class="sr-card__reject-box" *ngIf="pendingStatusFilter === 'rejected'">
                      <strong>Rejection reason</strong>
                      <p>{{ row.rejection_reason || 'No reason provided' }}</p>
                    </div>

                    <div class="sr-detail__actions" *ngIf="pendingStatusFilter === 'pending' && rejectingId !== row.id">
                      <button type="button" class="sr-btn sr-btn--approve" (click)="approvePending(row)">
                        <i class="pi pi-check"></i> Approve
                      </button>
                      <button type="button" class="sr-btn sr-btn--reject" (click)="rejectPending(row)">
                        <i class="pi pi-times"></i> Reject
                      </button>
                    </div>

                    <div class="sr-card__reject-form" *ngIf="pendingStatusFilter === 'pending' && rejectingId === row.id">
                      <label>Rejection reason <span class="sr-optional">(optional)</span></label>
                      <textarea
                        rows="3"
                        [(ngModel)]="rejectReason"
                        placeholder="e.g. duplicate registration, incomplete details…"
                      ></textarea>
                      <div class="sr-card__reject-actions">
                        <button type="button" class="sr-btn sr-btn--ghost" (click)="cancelReject()">Cancel</button>
                        <button type="button" class="sr-btn sr-btn--reject" (click)="confirmReject(row)">
                          <i class="pi pi-times"></i> Confirm reject
                        </button>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #srDetailEmpty>
                    <div class="sr-detail-empty">
                      <i class="pi pi-arrow-left"></i>
                      <p>Select a registration from the list to review details and approve or reject.</p>
                    </div>
                  </ng-template>
                </div>
              </div>
            </aside>
          </div>

          <div class="filters-grid">
            <input
              type="text"
              class="form-control filter-input"
              placeholder="Search name, number, contact, city..."
              [(ngModel)]="searchTerm"
              (ngModelChange)="onSearchTermChange()"
            />
            <select class="form-select filter-input" [(ngModel)]="selectedStatusFilter" (change)="applyPatientFilters()">
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            <select class="form-select filter-input" [(ngModel)]="selectedModeFilter" (change)="applyPatientFilters()">
              <option value="all">All Modes</option>
              <option value="opd">OPD</option>
              <option value="courier">Courier</option>
              <option value="nri">NRI</option>
            </select>
            <button class="btn clear-btn" type="button" (click)="clearFilters()">Clear</button>
          </div>

          <div class="table-wrap">
            <table class="table modern-table align-middle mb-0">
              <thead>
                <tr>
                  <th class="sortable" (click)="setSort('full_name')">Patient</th>
                  <th class="sortable" (click)="setSort('patient_number')">Patient No.</th>
                  <th class="sortable" (click)="setSort('age')">Age</th>
                  <th class="sortable" (click)="setSort('primary_contact')">Primary Contact</th>
                  <th class="sortable" (click)="setSort('gender')">Gender</th>
                  <th class="sortable" (click)="setSort('is_active')">Status</th>
                  <th class="sortable" (click)="setSort('isCourier')">Mode</th>
                  <th class="sortable" (click)="setSort('visit_fees')">Fees</th>
                  <th class="sortable" (click)="setSort('personal_dues')">Dues</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of paginatedPatients">
                  <td>{{ row.full_name || '-' }}</td>
                  <td>{{ row.patient_number || '-' }}</td>
                  <td>{{ row.age ?? '-' }}</td>
                  <td>{{ row.primary_contact | phoneFormat }}</td>
                  <td>{{ row.gender || '-' }}</td>
                  <td>
                    <span class="status-pill" [class.inactive]="(row.is_active || '').toLowerCase() === 'inactive'">
                      {{ row.is_active || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="mode-pill" [class.courier]="row.isCourier === 'COURIER'" [class.nri]="row.isCourier === 'NRI'">
                      {{ row.isCourier || 'OPD' }}
                    </span>
                  </td>
                  <td>{{ (row.visit_fees ?? 0) | currency:'INR':'symbol':'1.0-0' }}</td>
                  <td>{{ (row.personal_dues ?? 0) | currency:'INR':'symbol':'1.0-0' }}</td>
                  <td class="action-cell">
                    <button class="btn table-icon pay" type="button" title="Update Payments" (click)="openPaymentsDialog(row)">
                      <i class="pi pi-wallet"></i>
                    </button>
                    <button class="btn table-icon edit" type="button" title="Update Patient" (click)="openEditPatientDialog(row)">
                      <i class="pi pi-pencil"></i>
                    </button>
                    <button class="btn table-icon upload" type="button" title="Upload Reports" (click)="openReportsDialog(row)">
                      <i class="pi pi-upload"></i>
                    </button>
                    <button class="btn table-icon toggle" type="button" title="Toggle Active" (click)="confirmTogglePatient(row)">
                      <i class="pi pi-sync"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="!paginatedPatients.length">
                  <td colspan="10" class="empty-state">No patients found.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-footer">
            <div class="footer-meta">
              Showing {{ paginatedPatients.length }} of {{ patientListPagination.total }}
            </div>
            <div class="footer-controls">
              <select class="form-select page-size" [(ngModel)]="pageSize" (change)="updatePageSize()">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / page</option>
              </select>
              <button class="btn pager-btn" type="button" (click)="goToPreviousPage()" [disabled]="currentPage <= 1">Previous</button>
              <span class="page-indicator">Page {{ currentPage }} of {{ totalPages }}</span>
              <button class="btn pager-btn" type="button" (click)="goToNextPage()" [disabled]="currentPage >= totalPages">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="patientDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '80vw', maxWidth: '1100px' }"
  [header]="patient.id ? 'Update Patient' : 'Patient Registration Form'"
>
  <form class="row modern-reg-form" formsElement #patientForm="ngForm">
    <div class="container-fluid reg-shell">
      <div class="reg-topbar">
        <div>
          <h3 class="reg-title">Patient Registration</h3>
          <p class="reg-subtitle">Capture patient profile, contact, and billing preferences in one place.</p>
        </div>
        <div class="reg-status-pill">
          <i class="pi pi-shield"></i>
          Required fields marked with *
        </div>
      </div>

      <div class="reg-grid">
        <section class="reg-card">
          <div class="reg-section-title">
            <i class="pi pi-id-card"></i>
            Basic Details
          </div>
          <div class="row g-3">
            <div class="col-xl-4 col-md-6">
              <label>First Name <span class="text-danger">*</span></label>
              <input name="first_name" type="text" class="form-control" [(ngModel)]="patient.first_name" required />
            </div>
            <div class="col-xl-4 col-md-6">
              <label>Middle Name</label>
              <input name="middle_name" type="text" class="form-control" [(ngModel)]="patient.middle_name" />
            </div>
            <div class="col-xl-4 col-md-6">
              <label>Last Name <span class="text-danger">*</span></label>
              <input name="last_name" type="text" class="form-control" [(ngModel)]="patient.last_name" required />
            </div>
            <div class="col-xl-6 col-lg-8 col-md-12">
              <label>Age <span class="text-danger">*</span></label>
              <div class="age-input-with-hint">
                <input
                  name="age"
                  type="number"
                  class="form-control age-input-with-hint__input"
                  min="0"
                  max="150"
                  step="any"
                  [ngModel]="patient.age"
                  (ngModelChange)="onPatientAgeChange($event)"
                  (blur)="onPatientAgeBlur()"
                  placeholder="e.g. 2.08"
                  required
                />
                <small class="age-input-with-hint__text text-muted">
                  <i class="pi pi-info-circle"></i>{{ patientAgeHint }}
                </small>
              </div>
              <small class="text-danger d-block mt-1" *ngIf="patientAgeError">{{ patientAgeError }}</small>
            </div>
          </div>
        </section>

        <section class="reg-card">
          <div class="reg-section-title">
            <i class="pi pi-phone"></i>
            Contact & Profile
          </div>
          <div class="row g-3">
            <div class="col-xl-4 col-md-6">
              <label>Primary Contact <span class="text-danger">*</span></label>
              <input name="primary_contact" type="tel" maxlength="15" class="form-control" [(ngModel)]="patient.primary_contact" required />
            </div>
            <div class="col-xl-4 col-md-6">
              <label>Secondary Contact</label>
              <input name="secondary_contact" type="tel" maxlength="15" class="form-control" [(ngModel)]="patient.secondary_contact" />
            </div>
            <div class="col-xl-4 col-md-6">
              <label>Marital Status</label>
              <p-dropdown
                inputId="marital_status"
                name="marital_status"
                [options]="maritalStatusOptions"
                [(ngModel)]="patient.marital_status"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Status"
                appendTo="body"
                styleClass="w-100">
              </p-dropdown>
            </div>
            <div class="col-12">
              <label class="form-label d-block">Gender <span class="text-danger">*</span></label>
              <div class="gender-options">
                <label class="gender-pill">
                  <input type="radio" name="gender" value="Male" [(ngModel)]="patient.gender" required />
                  <span><i class="pi pi-mars"></i> Male</span>
                </label>
                <label class="gender-pill">
                  <input type="radio" name="gender" value="Female" [(ngModel)]="patient.gender" required />
                  <span><i class="pi pi-venus"></i> Female</span>
                </label>
                <label class="gender-pill">
                  <input type="radio" name="gender" value="Other" [(ngModel)]="patient.gender" required />
                  <span><i class="pi pi-user"></i> Other</span>
                </label>
              </div>
            </div>
          </div>
        </section>

        <section class="reg-card">
          <div class="reg-section-title">
            <i class="pi pi-heart"></i>
            Blood Group & Reference
          </div>
          <div class="row g-3 align-items-end">
            <div class="col-xl-8">
              <label class="form-label d-block">Blood Group</label>
              <div class="blood-options">
                <label class="blood-drop" *ngFor="let bg of ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']">
                  <input type="radio" name="blood_group" [value]="bg" [(ngModel)]="patient.blood_group" />
                  <div class="drop-icon">
                    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                      <path d="M32 2C32 2 12 26 12 40a20 20 0 0040 0C52 26 32 2 32 2z" />
                    </svg>
                    <span>{{ bg }}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <label>Referred By</label>
              <input name="referred_by" type="text" class="form-control" [(ngModel)]="patient.referred_by" />
            </div>
          </div>
        </section>

        <section class="reg-card">
          <div class="reg-section-title">
            <i class="pi pi-map-marker"></i>
            Address & Billing
          </div>
          <div class="row g-3">
            <div class="col-xl-4 col-md-6">
              <label>Address</label>
              <textarea name="address" class="form-control" rows="2" [(ngModel)]="patient.address"></textarea>
            </div>
            <div class="col-xl-2 col-md-6">
              <label>Country</label>
              <p-autoComplete
                name="country"
                [suggestions]="countrySuggestions"
                (completeMethod)="filterCountries($event)"
                (onSelect)="onCountrySelected()"
                [dropdown]="true"
                [forceSelection]="false"
                styleClass="w-100 location-autocomplete"
                panelStyleClass="location-autocomplete-panel"
                inputStyleClass="location-autocomplete-input"
                [(ngModel)]="patient.country">
              </p-autoComplete>
            </div>
            <div class="col-xl-2 col-md-6">
              <label>State</label>
              <p-autoComplete
                name="state"
                [suggestions]="stateSuggestions"
                (completeMethod)="filterStates($event)"
                (onSelect)="onStateSelected()"
                [dropdown]="true"
                [forceSelection]="false"
                [disabled]="(patient.country || '').toLowerCase() !== 'india'"
                styleClass="w-100 location-autocomplete"
                panelStyleClass="location-autocomplete-panel"
                inputStyleClass="location-autocomplete-input"
                [(ngModel)]="patient.state">
              </p-autoComplete>
            </div>
            <div class="col-xl-2 col-md-6">
              <label>City</label>
              <p-autoComplete
                name="city"
                [suggestions]="citySuggestions"
                (completeMethod)="filterCities($event)"
                [dropdown]="true"
                [forceSelection]="false"
                styleClass="w-100 location-autocomplete"
                panelStyleClass="location-autocomplete-panel"
                inputStyleClass="location-autocomplete-input"
                [(ngModel)]="patient.city">
              </p-autoComplete>
            </div>
            <div class="col-xl-2 col-md-6">
              <label>Pincode</label>
              <input name="pincode" type="text" class="form-control" [(ngModel)]="patient.pincode" />
            </div>
            <div class="col-xl-3 col-md-6">
              <label for="is_courier">Patient Mode</label>
              <p-dropdown
                inputId="is_courier"
                name="is_courier"
                [options]="patientModeOptions"
                [(ngModel)]="patient.is_courier"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                styleClass="w-100">
              </p-dropdown>
            </div>
            <div class="col-xl-2 col-md-6">
              <label>Fees</label>
              <input name="visit_fees" type="number" class="form-control" min="0" [(ngModel)]="patient.visit_fees" />
            </div>
          </div>
        </section>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="text-end w-100">
      <button
        class="btn reg-save-btn me-2"
        [disabled]="!patient.first_name || !patient.last_name || !isValidPatientAge(patient.age) || !patient.primary_contact || !patient.gender"
        (click)="processPatient()"
      >
        <i class="pi pi-check"></i>
        {{ patient.id ? 'Update' : 'Add' }} Patient
      </button>
      <button class="btn reg-cancel-btn" (click)="closeForm()">
        <i class="pi pi-times"></i> Cancel
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<p-dialog header="Reports" [(visible)]="openUploadReportDialog" [modal]="true"
      [maximizable]="true" [style]="{width: '80%', minHeight: '600px'}" [draggable]="false"
      [resizable]="false">
            <section class="pr-reports-shell">
              <div class="row mb-3 align-items-end pr-reports-head">
                <div class="col-md-6">
                  <div class="pr-upload-top">
                    <div class="pr-upload-icon">
                      <i class="pi pi-cloud-upload"></i>
                    </div>
                    <div class="pr-upload-copy">
                      <h6 class="mb-1">Upload Documents / Images</h6>
                      <p class="mb-0">PNG, JPG, PDF up to 5 MB each</p>
                    </div>
                  </div>

                  <div class="pr-upload-actions">
                    <input id="docUpload" type="file" class="pr-upload-input" multiple accept="image/png, image/jpeg, image/jpg, image/png, application/pdf"
                      (change)="onFileSelect($event)" />
                    <label for="docUpload" class="pr-upload-trigger">
                      <i class="pi pi-folder-open"></i>
                      Choose Files
                    </label>
                    <button class="pr-upload-btn" type="button" [disabled]="!pendingFiles.length"
                      (click)="onUploadSelectedFiles()">
                      <i class="pi pi-check-circle"></i>
                      Upload
                    </button>
                  </div>

                  <div class="pr-upload-meta">
                    <span class="file-count" *ngIf="pendingFiles.length; else noPrFilesSelected">
                      {{ pendingFiles.length }} file(s) selected
                    </span>
                    <ng-template #noPrFilesSelected>
                      <span class="file-count empty">No files selected</span>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-6 mt-3 mt-md-0">
                  <label class="form-label fw-semibold">Save Text Report</label>
                  <input
                    type="text"
                    class="form-control mb-2 pr-text-input"
                    placeholder="Text report title (optional)"
                    [(ngModel)]="reportTextTitle"
                  />
                  <textarea
                    class="form-control mb-2 pr-text-input"
                    rows="4"
                    placeholder="Write text report..."
                    [(ngModel)]="reportTextContent"
                  ></textarea>
                  <button
                    class="pr-upload-btn pr-text-save-btn"
                    type="button"
                    [disabled]="!reportTextContent.trim() || isSavingTextReport"
                    (click)="saveTextReport()"
                  >
                    {{ isSavingTextReport ? 'Saving...' : 'Save Text Report' }}
                  </button>
                </div>
              </div>

              <div class="gallery mt-4 pr-gallery">
                <div *ngIf="uploadsByDate.length; else noUploads">
                  <section *ngFor="let group of uploadsByDate" class="pr-date-group mb-4">
                    <div class="pr-date-head">
                      <h6 class="pr-date-label mb-0">
                        <i class="pi pi-calendar"></i>
                        {{ group.date | date: 'fullDate' }}
                      </h6>
                      <span class="pr-file-count">{{ group.files.length || 0 }} files</span>
                    </div>

                    <div class="pr-report-grid mt-3">
                      <article *ngFor="let file of group.files"
                        class="pr-file-card"
                        (click)="openFile(file)">
                        <button type="button"
                          class="report-delete-btn"
                          title="Delete report"
                          (click)="deleteUploadedReport(file, $event)">
                          <i class="pi pi-trash"></i>
                        </button>

                        <ng-container *ngIf="file.kind === 'text'; else prNonTextTemplate">
                          <div class="pr-doc-preview">
                            <i class="pi pi-align-left"></i>
                          </div>
                        </ng-container>

                        <ng-template #prNonTextTemplate>
                          <ng-container *ngIf="file.type?.startsWith('image/'); else prDocTemplate">
                            <img [src]="file.url" class="pr-file-image" alt="uploaded image" />
                          </ng-container>
                        </ng-template>

                        <ng-template #prDocTemplate>
                          <div class="pr-doc-preview">
                            <i class="pi pi-file-pdf"></i>
                          </div>
                        </ng-template>

                        <div class="pr-file-meta">
                          <div class="pr-file-name" [title]="file.name">{{ file.name }}</div>
                          <div class="pr-file-type">{{ file.kind === 'text' ? 'Text' : (file.type?.startsWith('image/') ? 'Image' : 'Document') }}</div>
                        </div>
                      </article>
                    </div>
                  </section>
                </div>

                <ng-template #noUploads>
                  <div class="pr-empty-state">
                    <i class="pi pi-folder-open"></i>
                    <p>No documents or images uploaded yet.</p>
                  </div>
                </ng-template>
              </div>
            </section>

    <ng-template pTemplate="footer">
    <!-- <p-button label="Cancel" severity="secondary" (onClick)="visible = false" />
    <p-button label="Save" (onClick)="changeStatus(selectedPatient)" /> -->
    <button type="submit" class="btn bg-light-green" (click)="uploadPendingFiles()" style="margin-right: 10px;">Upload</button>
    <button type="button" class="btn btn-secondary" (click)="closeUploadReportDialog()">Cancel</button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="openPaymentDialog"
  [modal]="true"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(920px, 94vw)' }"
  styleClass="payments-dialog"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
  (onHide)="closePaymentDialog()">

  <ng-template pTemplate="header">
    <div class="pay-dialog-head">
      <div class="pay-dialog-head__icon" aria-hidden="true">
        <i class="pi pi-wallet"></i>
      </div>
      <div class="pay-dialog-head__copy">
        <p class="pay-dialog-kicker">Collections</p>
        <h2 class="pay-dialog-title">
          {{ selectedPatient?.full_name || 'Patient payments' }}
        </h2>
        <p class="pay-dialog-sub" *ngIf="selectedPatient">
          {{ selectedPatient.patient_number }}
          <span *ngIf="selectedPatient.id"> · #{{ selectedPatient.id }}</span>
        </p>
      </div>
    </div>
  </ng-template>

  <div class="pay-dialog-body">
    <section class="pay-settle" *ngIf="latestDueAmount > 0; else duesCleared">
      <div class="pay-metric">
        <span class="pay-metric__label">Due</span>
        <span class="pay-metric__value pay-metric__value--due">{{ latestDueAmount | currency:'INR':'symbol':'1.0-0' }}</span>
      </div>

      <div class="pay-metric">
        <span class="pay-metric__label">After</span>
        <span class="pay-metric__value pay-metric__value--remain">{{ remainingAfterPay | currency:'INR':'symbol':'1.0-0' }}</span>
      </div>

      <div class="pay-settle__divider" aria-hidden="true"></div>

      <div class="pay-field pay-field--amount">
        <label for="payAmountInput">Amount</label>
        <div class="pay-amount-wrap">
          <span class="pay-amount-prefix">₹</span>
          <input
            id="payAmountInput"
            type="number"
            class="pay-amount-input"
            [(ngModel)]="payAmount"
            (ngModelChange)="onPayAmountChange($event)"
            [max]="latestDueAmount"
            min="1"
            step="1"
            placeholder="0" />
          <button
            type="button"
            class="pay-full-btn"
            (click)="payFullDue()"
            [disabled]="latestDueAmount <= 0">
            Full
          </button>
        </div>
      </div>

      <div class="pay-field pay-field--mode">
        <label>Mode</label>
        <div class="pay-mode-chips" role="group" aria-label="Payment mode">
          <button
            type="button"
            class="pay-mode-chip"
            *ngFor="let mode of paymentModes"
            [class.is-active]="selectedPaymentMode === mode.value"
            (click)="selectedPaymentMode = mode.value">
            <i [class]="paymentModeIcon(mode.value)"></i>
            {{ mode.label }}
          </button>
        </div>
      </div>

      <button
        type="button"
        class="pay-settle-btn"
        [disabled]="!canSettlePayment() || settlingPayment"
        (click)="settleLatestDue()">
        <i class="pi" [ngClass]="settlingPayment ? 'pi-spin pi-spinner' : 'pi-check'"></i>
        {{ settlingPayment ? 'Settling…' : 'Settle' }}
      </button>
    </section>

    <ng-template #duesCleared>
      <section class="pay-cleared">
        <div class="pay-cleared__icon"><i class="pi pi-check-circle"></i></div>
        <div>
          <h3>No outstanding dues</h3>
          <p>This patient has no pending balance to settle right now.</p>
        </div>
      </section>
    </ng-template>

    <section class="pay-history">
      <div class="pay-history__head">
        <h3>Payment history</h3>
        <span class="pay-history__count" *ngIf="pagination.total">{{ pagination.total }} records</span>
      </div>

      <p-table
        [value]="paymentHistory"
        [paginator]="true"
        [rows]="pagination.per_page"
        [totalRecords]="pagination.total"
        [lazy]="true"
        (onLazyLoad)="loadPayments($event)"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        styleClass="p-datatable-sm pay-history-table"
        responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th>Date</th>
            <th>Amount paid</th>
            <th>Mode</th>
            <th>Visit fees</th>
            <th>Remaining due</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-payment>
          <tr>
            <td class="pay-date">
              {{ (payment.payment_date || payment.date) | date:'dd MMM yyyy, hh:mm a' }}
            </td>
            <td class="pay-amount-paid">
              {{ (payment.amount ?? 0) | currency:'INR':'symbol':'1.0-0' }}
            </td>
            <td>
              <span class="pay-mode-tag" [attr.data-mode]="payment.payment_mode || 'unknown'">
                <i [class]="paymentModeIcon(payment.payment_mode)"></i>
                {{ paymentModeLabel(payment.payment_mode) }}
              </span>
            </td>
            <td>
              {{ (payment.visit_fees ?? payment.raw_response?.meta?.visit_fees ?? 0) | currency:'INR':'symbol':'1.0-0' }}
            </td>
            <td class="pay-remaining">
              {{ (payment.due_amount ?? payment.raw_response?.meta?.personal_dues ?? 0) | currency:'INR':'symbol':'1.0-0' }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">
              <div class="pay-empty">
                <i class="pi pi-inbox"></i>
                <p>No payment records yet for this patient.</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="pay-cancel-btn" (click)="closePaymentDialog()">Close</button>
  </ng-template>
</p-dialog>

<p-confirmPopup key="reportDeleteConfirm"></p-confirmPopup>
